import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';
import { ResponseContentType, Response } from '@angular/http';

@Injectable()
export class DiscountService {
  // private http: Http, 
  constructor(private authHttp: AuthHttp) { }

  getDiscounts(){
      return this.authHttp.get('/api/discounts').map(res => res.json());
  }

  getDiscountById(id: number){
      return this.authHttp.get('/api/discounts/'+id).map(res => res.json());
  }

  updateDiscountById(discount:any){
    return this.authHttp
      .put("/api/discounts/" + discount.id, discount)
      .map(res => res.json());
  }

  createDiscount(discount: any) {
    // console.log("Create Discount: "+JSON.stringify(discount))
    return this.authHttp.post("/api/discounts/", discount).map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete("/api/discounts/" + id).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  
  downloadYearOverviewDiscountUsed (year: number){
    return this.authHttp.get('/api/discounts/getYearOverviewDiscountUsedXlsx/'+year, {responseType: ResponseContentType.Blob}).map((res: Response )=> {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/discount.service.ts